'use client';

import { useFloatingInputBarHeight } from './floating-input-bar-context';

// Invisible placeholder that reserves vertical space equal to the floating input bar's height,
// preventing fixed-positioned bar from overlapping page content.
export function FloatingInputBarSpacer() {
    const { height } = useFloatingInputBarHeight();
    return <div style={{ height }} aria-hidden />;
}
